export default __webpack_public_path__ + "static/media/bag.cf674b06.png";